import React from "react";
import {
  TrendingUp,
  TrendingDown,
  Building,
  Database,
  Gauge,
  BarChart3,
} from "lucide-react";
import { useMeterModelSummary } from "../hooks";
import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";

interface KpiCardsProps {
  remote_utility_id: any;
}

export const KpiCards: React.FC<KpiCardsProps> = ({ remote_utility_id }) => {
  const { data } = useMeterModelSummary({ remote_utility_id });
  const cards = [
    {
      title: "Total Manufacturers",
      value: data?.result.totalManufacturers,
      trend: `${data?.result.manufacturerPercentChange} new this quarter`,
      icon: <Building  className="h-5 w-5 text-blue-600"/>,
      color: "text-blue-600",
      bgColor: "bg-blue-50",
    },
    {
      title: "Total Models",
      value: data?.result.totalModels,
      trend: `${data?.result.modelPercentChange} added this month`,
      icon: <Database  className="h-5 w-5 text-purple-600" />,
      color: "text-purple-600",
      bgColor: "bg-purple-50",
    },
    {
      title: "Total Meters",
      value: data?.result.totalMeters,
      icon: <Gauge className="h-5 w-5 text-green-600"/>,
      color: "text-green-600",
      bgColor: "bg-green-50",
    },
    {
      title: "Avg Meters per Model",
      value: data?.result.avgMetersPerModel,
      icon: <BarChart3 className="h-5 w-5 text-orange-600" />,
      color: "text-orange-600",
      bgColor: "bg-orange-50",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {cards.map((card, index) => (
        // <div key={index} className="bg-white rounded-lg shadow-md p-6">
        //   <div className="flex items-center justify-between">
        //     <div className="flex-1">
        //       <p className="text-sm font-medium text-gray-600 mb-1">
        //         {card.title}
        //       </p>
        //       <p className="text-2xl font-bold text-gray-900 mb-2">
        //         {card.value}
        //       </p>
        //       <div className="flex items-center text-sm">
        //         {parseFloat(card.trend) > 0 ? (
        //           <TrendingUp className="w-4 h-4 text-green-500 mr-1" />
        //         ) : parseFloat(card.trend) < 0 ? (
        //           <TrendingDown className="w-4 h-4 text-red-500 mr-1" />
        //         ) : null}
        //         <span
        //           className={`${
        //             parseFloat(card.trend) > 0
        //               ? "text-green-600"
        //               : parseFloat(card.trend) < 0
        //               ? "text-red-600"
        //               : "text-gray-500"
        //           }`}
        //         >
        //           {card.trend}
        //         </span>
        //       </div>
        //     </div>
        //     <div className={`p-3 rounded-full ${card.bgColor}`}>
        //       <card.icon className={`w-6 h-6 ${card.color}`} />
        //     </div>
        //   </div>
        // </div>
        <QuickStatsCard title={card.title} count={card.value} icon={card.icon} trendSummary={card.trend} />
      ))}
    </div>
  );
};
